import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { greeting, projectsHeader } from "../../portfolio.js";
import ProjectsData from "../../shared/opensource/projects.json";
import ProjectsImg from "./ProjectsImg";
import ProjectDetail from "./ProjectDetail";
import "./Projects.css";
import "./ProjectDetail.css";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProject: null,
    };

    this.handleRepoCardClick = this.handleRepoCardClick.bind(this);
    this.handleCloseProjectDetail = this.handleCloseProjectDetail.bind(this);
  }

  handleRepoCardClick(projectData) {
    this.setState({ selectedProject: projectData });
  }

  handleCloseProjectDetail() {
    this.setState({ selectedProject: null });
  }

  render() {
    const theme = this.props.theme;
    const { selectedProject } = this.state;

    return (
      <div className="projects-main">
        <Header theme={theme} />

        {selectedProject && (
          <ProjectDetail
            project={selectedProject}
            show={!!selectedProject}
            onClose={this.handleCloseProjectDetail}
          />
        )}

        <div className={`basic-projects ${selectedProject ? "blur" : ""}`}>
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader.description}
                </p>
              </div>
            </div>
          </Fade>
        </div>

        <div className="repo-cards-div-main">
          {ProjectsData.data.map((repo) => (
            <GithubRepoCard
              key={repo.id}
              repo={repo}
              theme={theme}
              onCardClick={() => this.handleRepoCardClick(repo)}
            />
          ))}
        </div>

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
